import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { MemberAppDataService } from '../services';
import { GlobalDomOpsService } from '@acepteam/globalspack';
import { first } from 'rxjs/operators';
import { DataService } from '../../core/services';

@Injectable({
  providedIn: 'root'
})
export class ChapterLobbyDataResolve implements Resolve<any> {

  constructor(private service: DataService, private globaldomops: GlobalDomOpsService) {}

  resolve(route: ActivatedRouteSnapshot) {    
    return this.service.GetChapterlobbyData().pipe(first()); //take(1) // To make the observable complete after the first emission;
  }

}

